import React from 'react';
import { ErrorMessage } from '@hookform/error-message';
import { Checkbox, checkboxClasses, FormControlLabel } from '@mui/material';
import identity from 'lodash/identity';
import { Controller, useFormContext } from 'react-hook-form';

import { Text } from '@src/components/Typography';
import { palette } from '@src/theme';
import { getTestId } from '@src/utils/testIds';
import { CheckboxFieldProps } from './interface';

export const CheckboxField = (props: CheckboxFieldProps) => {
  const {
    formatOnChange = identity,
    label,
    name,
    parseValue = identity,
    parseError = parseValue,
  } = props;
  const {
    control,
    formState: { errors },
    trigger,
  } = useFormContext();

  const fieldErrors = errors[name];

  const parsedErrors = fieldErrors ? { [name]: parseError(fieldErrors) } : {};

  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value: fieldValue }, fieldState: { error } }) => (
          <FormControlLabel
            control={
              <Checkbox
                name={name}
                value={parseValue(fieldValue)}
                checked={!!parseValue(fieldValue)}
                onChange={(e) => {
                  const val = e.target.checked;
                  const newVal = formatOnChange(val, fieldValue);
                  onChange(newVal);
                  if (error) {
                    trigger(name);
                  }
                }}
                color="primary"
                sx={{
                  [`&, &.${checkboxClasses.checked}, &.${checkboxClasses.indeterminate}`]: {
                    color: error ? palette.state.error.secondary : palette.state.teal.secondary,
                  },
                }}
                data-testid={getTestId(props)}
              />
            }
            label={label}
            sx={{
              '& .MuiTypography-root': {
                lineHeight: 2,
              },
            }}
          />
        )}
      />
      <ErrorMessage
        name={name}
        errors={parsedErrors}
        render={({ message }) => (
          <Text size="s" color="state.error.secondary">
            {message}
          </Text>
        )}
      />
    </>
  );
};
